import React from 'react';
import Login from '../pages/auth/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import Dashboard from '../pages/dashboard/Dashboard';
import ChangePassword from '../pages/dashboard/ChangePassword';
import ManageCategory from '../pages/category/ManageCategory';
import AddUpdateCategory from '../pages/category/AddUpdateCategory';
import CategoryDetails from '../pages/category/CategoryDetails';
import Configuration from '../pages/configuration/Configuration';
import ManageTemplate from '../pages/email-template/ManageTemplate';
import UpdateTemplate from '../pages/email-template/UpdateTemplate';
import ManageProjects from '../pages/projects/ManageProjects';
import ManageUsers from '../pages/users/ManageUsers';
import UserDetails from '../pages/users/UserDetails';

import ManageNFT from '../pages/stored-nft/ManageNFT';
import NFTDetails from '../pages/stored-nft/NFTDetails';
import ManageFiatTransaction from '../pages/transactions/ManageFiatTransaction';
import ManageCMS from '../pages/cms/ManageCMS';
import CMSDetails from '../pages/cms/CMSDetails';
import UpdateCMS from '../pages/cms/UpdateCMS';
import ProjectDetails from '../pages/projects/ProjectDetails';
import Payout from '../pages/payout/Payout';
import PayoutUserList from '../pages/payout/PayoutUserList';
import PageNotFound from '../components/PageNotFound';
import VoucherDetails from '../pages/vouchers/VoucherDetails';
import ManageVouchers from '../pages/vouchers/ManageVouchers';
import ManageActivityLogs from '../pages/activity-logs/ManageActivityLogs';
import AddEditProject from '../pages/projects/AddEditProject';
import AddEditVoucher from '../pages/vouchers/AddEditVoucher';

/*
Note: Dont use statis routes for appBaseEndpoint and fallbackEndpoint, import below variables instead wherever necessary in the pages
*/
/* 
path: Path of the endpoint
component: Pass the component which you want to render on given path
isGaurded: Set to true if want the page protected or else pass false
redirectTo (optional): Pass the desired path where you want to redirect when the path matches with the active path
*/
export const mainRoutes = [
  //Auth
  {
    path: '/login',
    element: <Login />,
    isGuarded: false,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
    isGuarded: false,
  },
  {
    path: '/reset-password/:token',
    element: <ResetPassword />,
    isGuarded: false,
  },

  //dashboard
  {
    path: '/',
    element: <Dashboard />,
    isGuarded: true,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
    isGuarded: true,
  },
  //change password
  {
    path: '/change-password',
    element: <ChangePassword />,
    isGuarded: true,
  },
  //configuration
  {
    path: '/configuration',
    element: <Configuration />,
    isGuarded: true,
  },

  //category
  {
    path: '/category/list',
    element: <ManageCategory />,
    isGuarded: true,
  },
  {
    path: '/category/add',
    element: <AddUpdateCategory />,
    isGuarded: true,
  },
  {
    path: '/category/edit',
    element: <AddUpdateCategory />,
    isGuarded: true,
  },
  {
    path: '/category/details/:id',
    element: <CategoryDetails />,
    isGuarded: true,
  },

  //email-template
  {
    path: '/email-template/list',
    element: <ManageTemplate />,
    isGuarded: true,
  },
  {
    path: '/email-template/update',
    element: <UpdateTemplate />,
    isGuarded: true,
  },

  // projects
  {
    path: '/assets',
    element: <ManageProjects />,
    isGuarded: true,
  },
  {
    path: '/assets/addedit/:id?',
    element: <AddEditProject />,
    isGuarded: true,
  },

  {
    path: '/assets/view/:id',
    element: <ProjectDetails />,
    isGuarded: true,
  },

  //voucher
  {
    path: '/vouchers/list',
    element: <ManageVouchers />,
    isGuarded: true,
  },
  {
    path: '/vouchers/addedit/:id?',
    element: <AddEditVoucher />,
    isGuarded: true,
  },
  {
    path: '/vouchers/view/:id',
    element: <VoucherDetails />,
    isGuarded: true,
  },

  // users
  {
    path: '/users/list',
    element: <ManageUsers />,
    isGuarded: true,
  },

  {
    path: '/users/view/:id',
    element: <UserDetails />,
    isGuarded: true,
  },

  //stored NFT
  {
    path: '/nft/list',
    element: <ManageNFT />,
    isGuarded: true,
  },
  {
    path: '/nft/view/:id',
    element: <NFTDetails />,
    isGuarded: true,
  },

  //transaction
  {
    path: '/transactions/fiat/list',
    element: <ManageFiatTransaction />,
    isGuarded: true,
  },
  /*   {
    path: "/transactions/onchain/list",
    element:  <ManageOnchainTransaction/> ,
    isGuarded: true,
  }, */

  //cms
  {
    path: '/cms/list',
    element: <ManageCMS />,
    isGuarded: true,
  },
  {
    path: '/cms/view/:id',
    element: <CMSDetails />,
    isGuarded: true,
  },
  {
    path: '/cms/edit',
    element: <UpdateCMS />,
    isGuarded: true,
  },
  //payout
  {
    path: '/payout/list',
    element: <Payout />,
    isGuarded: true,
  },
  {
    path: '/payout/user-payout-list/:project_id/:payout_id',
    element: <PayoutUserList />,
    isGuarded: true,
  },
  {
    path: '*',
    element: <PageNotFound />,
    isGuarded: true,
  },

  //activity logs
  {
    path: '/activity-logs/list',
    element: <ManageActivityLogs />,
    isGuarded: true,
  },
];
